export const getUserDetails = (): any => {
  return JSON.parse(localStorage.getItem('user') || '{}') || {};
};

export const getRoleNameList = (): string[] => {
  return (getUserDetails()?.userRoles || []).map( itm => itm.roleName); 
};
let clickedParamsForAudit: any;
export function setclickedParamsForAudit(params: any) {
  clickedParamsForAudit = params?.data;
}
export function getclickedParamsForAudit() {
  return clickedParamsForAudit;
}
let userExamDetailsMap = {};

export function setUserExamDetails(obj: any) {
  userExamDetailsMap = obj;
}
export function getUserExamDetails() {
  return userExamDetailsMap;
}
